import { appEnvironmentBadgeLabel } from "../../../constants/appEnvironment";
import "./EnvBadge.css";

/**
 * Indicador de ambiente não-PRD (DEV / IST / UAT / …).
 * Não renderiza em produção.
 */
export function EnvBadge({ className = "" }) {
  const label = appEnvironmentBadgeLabel();
  if (!label) return null;
  return (
    <span
      className={["spm-env-badge", className].filter(Boolean).join(" ")}
      role="status"
      title={`Ambiente ${label} (não produção)`}
      data-env={label.toLowerCase()}
    >
      {label}
    </span>
  );
}

export default EnvBadge;
